import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SessionStorageService } from '../common/service/session-storage.service';
import { SESSION_STORAGE_TOKEN } from '../common/service/tokens';
import { SharedModule } from '../shared/shared.module';
import { QualificationService } from './services/qualifications.service';
import { ReviewLabelService } from './services/review-label.service';
import { TenantService } from './services/tenant.service';
import { UserService } from './services/user.service';
import { ViolationService } from './services/violations.service';
import { ContractService } from './services/contracts.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    CommonModule,
    SharedModule
  ]
})
export class SakpSharedModule {
  static forRoot(): ModuleWithProviders<SakpSharedModule> {
    return {
      ngModule: SakpSharedModule,
      providers: [
        ReviewLabelService,
        ContractService,
        ViolationService,
        QualificationService,
        TenantService,
        UserService,
        { provide: SESSION_STORAGE_TOKEN, useValue: 'sakp' },
        SessionStorageService
      ]
    };
  }
}
